import type { ReactNode } from 'react';

interface PanelProps {
  title: ReactNode;
  meta?: ReactNode;
  children: ReactNode;
  id?: string;
  className?: string;
  level?: 2 | 3;
}

export function Panel({ title, meta, children, id, className, level = 2 }: PanelProps) {
  const headingId = id ? `${id}-title` : undefined;
  const Heading = level === 2 ? 'h2' : 'h3';
  return (
    <section className={`panel ${className ?? ''}`} aria-labelledby={headingId} id={id}>
      <header className="panel__head">
        <Heading id={headingId}>{title}</Heading>
        {meta ? <span className="panel__meta">{meta}</span> : null}
      </header>
      {children}
    </section>
  );
}

export function Empty({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="empty" role="note">
      <p className="empty__title">{title}</p>
      {children ? <p className="small">{children}</p> : null}
    </div>
  );
}

export function Banner({
  tone,
  title,
  children,
  icon,
}: {
  tone: 'warn' | 'danger' | 'info' | 'fallback';
  title: string;
  children?: ReactNode;
  icon?: string;
}) {
  const role = tone === 'danger' || tone === 'fallback' ? 'alert' : 'status';
  return (
    <div className={`banner banner--${tone}`} role={role}>
      <span className="banner__icon" aria-hidden="true">
        {icon ?? (tone === 'info' ? 'ℹ' : '⚠')}
      </span>
      <div>
        <strong>{title}</strong>
        {children ? <div className="small">{children}</div> : null}
      </div>
    </div>
  );
}
